var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.desserts,"sort-by":['calories', 'fat'],"sort-desc":[false, true],"multi-sort":""}})}
var staticRenderFns = []

export { render, staticRenderFns }